import { render, staticRenderFns } from "./PaymentTypeList.vue?vue&type=template&id=55673b90&"
import script from "./PaymentTypeList.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypeList.vue?vue&type=style&index=0&id=55673b90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports